<template>
    <div class="form-pack">
        <h2 class="pack-pretitle">VOTRE PACK</h2>
        <h3 class="pack-title">Vous bénéficiez de</h3>
        <ul class="pack-list">
            <li>
                <img class="list-check" src="/images/fr_new_home/Atom/Icon/LIST/green-check.svg">
                <div>
                    <img class="pack-img" :src="form_side_image">
                    Votre cadeau de bienvenue au choix
                </div>
            </li>
            <li>
                <img class="list-check" src="/images/fr_new_home/Atom/Icon/LIST/green-check.svg">
                <p><strong>Pack découverte :</strong><br>3 mois offerts</p>
            </li>
            <li v-for="item in pack_list">
                <img class="list-check" src="/images/fr_new_home/Atom/Icon/LIST/green-check.svg">{{item}}
            </li>
        </ul>
    </div>
</template>

<script>
import image_mixin from "../mixins/image_mixin";

export default {
    name: "PackComponent",
    mixins:[
        image_mixin
    ],
    data() {
        return {
            pack_list: [
                'Vos magazines en version papier et numérique',
                'Une assistance juridique, fiscale et technique illimitée',
                '12 guides pratiques au choix par an',
                'Vous restez libre d\'interrompre votre abonnement à tout moment'
            ]
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
